import { RouterProvider } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { system } from 'theme';
import GlobalStyle from 'theme/Global';
import { router } from 'wrappers';

import { createQueryClient } from 'utils';
import { ToastProvider } from 'utils/toast';

if (!localStorage.getItem('referrer')) {
  localStorage.setItem('referrer', document.referrer);
}

const queryClient = createQueryClient();

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider value={system}>
        <ToastProvider />
        <GlobalStyle />
        <RouterProvider router={router} />
      </ChakraProvider>
    </QueryClientProvider>
  );
};
